import React, { Fragment } from 'react';

import './element_loader.css'

const ElementLoader = (props) => {
  let { loading, message } = props;
  message = message || "Loading"
  return (
    <Fragment>
      {
        loading
        ? 
        <div className="element-loader">
          <i className="loading circle notched icon"></i>
          <span>{ message }</span>
        </div>
        :
        <div></div>
      }
    </Fragment>
  )
}

export default ElementLoader;


// WEBPACK FOOTER //
// ./src/views/components/element_loader/element_loader.js